var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.084,
    height: 28.8,
    viewBox: "0 0 22.084 28.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "addAccount",
    transform: "translate(-299.16 -92.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M310.2,94.408a1.312,1.312,0,1,0,1.311,1.311A1.313,1.313,0,0,0,310.2,94.408Zm0,1.779a.468.468,0,1,1,.468-.468A.469.469,0,0,1,310.2,96.187Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_295",
    "data-name": "Group 295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_294",
    "data-name": "Group 294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M306.313,97.556a.421.421,0,0,0-.422.421v.7a.422.422,0,1,0,.843,0v-.7A.42.42,0,0,0,306.313,97.556Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_296",
    "data-name": "Group 296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M314.091,97.556a.421.421,0,0,0-.422.421v.7a.422.422,0,0,0,.844,0v-.7A.421.421,0,0,0,314.091,97.556Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M311.439,98.315a.42.42,0,0,0-.6.04.876.876,0,0,1-1.284,0,.422.422,0,0,0-.636.555,1.719,1.719,0,0,0,2.555,0A.42.42,0,0,0,311.439,98.315Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M314.852,109.9h-9.3a.422.422,0,0,0,0,.844h9.3a.422.422,0,0,0,0-.844Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M314.852,112.452h-9.3a.422.422,0,0,0,0,.844h9.3a.422.422,0,1,0,0-.844Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M314.852,115h-9.3a.422.422,0,0,0,0,.844h9.3a.422.422,0,0,0,0-.844Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M312.588,104.3h-1.075v-1.074a.421.421,0,0,0-.421-.422h-1.78a.421.421,0,0,0-.422.422V104.3h-1.074a.422.422,0,0,0-.422.422V106.5a.422.422,0,0,0,.422.422h1.074V108a.422.422,0,0,0,.422.422h1.78a.421.421,0,0,0,.421-.422V106.92h1.075a.422.422,0,0,0,.422-.422v-1.779A.422.422,0,0,0,312.588,104.3Zm-.422,1.78h-1.074a.421.421,0,0,0-.422.421v1.075h-.936V106.5a.421.421,0,0,0-.422-.421h-1.074v-.936h1.074a.422.422,0,0,0,.422-.422v-1.075h.936v1.075a.422.422,0,0,0,.422.422h1.074Z",
    fill: "#6c5b7b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M318.793,97.375h-1.8v-.663a1.271,1.271,0,0,0-1.269-1.269h-2.632a2.918,2.918,0,0,0-5.775,0h-2.631a1.271,1.271,0,0,0-1.269,1.269v.663h-1.8a2.454,2.454,0,0,0-2.451,2.452V119.3a2.454,2.454,0,0,0,2.451,2.451h2.026a.422.422,0,0,0,0-.844h-2.026A1.61,1.61,0,0,1,300,119.3V99.827a1.61,1.61,0,0,1,1.608-1.608h1.8v1.094h-1.8a.514.514,0,0,0-.514.514V119.3a.515.515,0,0,0,.514.514h17.182a.514.514,0,0,0,.513-.514V99.827a.514.514,0,0,0-.513-.514h-1.8V98.219h1.8a1.609,1.609,0,0,1,1.607,1.608V119.3a1.609,1.609,0,0,1-1.607,1.607H305.324a.422.422,0,0,0,0,.844h13.469a2.454,2.454,0,0,0,2.451-2.451V99.827A2.455,2.455,0,0,0,318.793,97.375Zm-.33,2.782v18.809H301.941V100.157h1.473v.09a1.27,1.27,0,0,0,1.269,1.269h8.179a.422.422,0,0,0,0-.844h-8.179a.426.426,0,0,1-.426-.425V96.712a.426.426,0,0,1,.426-.425h3.023a.422.422,0,0,0,.422-.422,2.074,2.074,0,0,1,4.148,0,.422.422,0,0,0,.422.422h3.023a.425.425,0,0,1,.425.425v3.535a.425.425,0,0,1-.425.425h-1.172a.422.422,0,0,0,0,.844h1.172a1.27,1.27,0,0,0,1.269-1.269v-.09Z",
    fill: "#6c5b7b"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAccount);
export default __webpack_public_path__ + "static/media/addAccount.0b6395a405789633aaf6258f17038532.svg";
export { ForwardRef as ReactComponent };